import { useTexts } from '../hooks/useTexts'
import { CompanyEmail } from './fields/CompanyEmail'
import { CompanyName } from './fields/CompanyName'
import { CompanyPhone } from './fields/CompanyPhone'
import { CompanySlogan } from './fields/CompanySlogan'
import { Pods } from './fields/Pods'
import { ShowETARange } from './fields/ShowETARange'
import { form } from './formState'

export function TrackingPageForm() {
  const texts = useTexts()

  return (
    <>
      <form.SectionTitle variant="alternative">{texts.companyInformation}</form.SectionTitle>
      <CompanyName />
      <CompanySlogan />
      <CompanyPhone />
      <CompanyEmail />
      <form.Divider />
      <ShowETARange />
      <form.Divider />
      <Pods />
    </>
  )
}
